import { render, staticRenderFns } from "./InfoPriceProductModal.vue?vue&type=template&id=4a28bc9f&scoped=true"
import script from "./InfoPriceProductModal.vue?vue&type=script&lang=js"
export * from "./InfoPriceProductModal.vue?vue&type=script&lang=js"
import style0 from "./InfoPriceProductModal.vue?vue&type=style&index=0&id=4a28bc9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28bc9f",
  null
  
)

export default component.exports